import {
  phosphorIcons
} from "./chunk-KUOF7LLD.js";

// src/Iconify.tsx
import { template as _$template } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { spread as _$spread } from "solid-js/web";
import { mergeProps as _$mergeProps } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import classNames from "classnames";
import { uniqueId } from "lodash-es";
import { createMemo, splitProps } from "solid-js";
import { mapArrayToObj } from "@wovin/utils/types";
var _tmpl$ = /* @__PURE__ */ _$template(`<div>`);
var IconifyNames = mapArrayToObj(phosphorIcons);
var Iconify = (fullProps) => {
  const [props, otherProps] = splitProps(fullProps, ["class", "size", "scale", "name", "style", "customSVG"]);
  const cursorClass = typeof otherProps.onclick === "function" ? "cursor-pointer" : "";
  const sizes = createMemo(() => props.size ? typeof props.size === "string" && props.size.includes(" ") ? props.size.split(" ") : [props.size, props.size] : [4, 4]);
  const iconUUID = `iconify-${uniqueId()}`;
  return (() => {
    var _el$ = _tmpl$();
    _$setAttribute(_el$, "id", iconUUID);
    _$spread(_el$, _$mergeProps({
      get ["class"]() {
        return classNames(
          // 'iconify-n3',
          props.class,
          cursorClass,
          props.name && (props.name.includes(":") ? "" : "i-ph:") + props.name,
          // can serve as a placeholder for an icon that is there sometimes
          `w-${sizes()[0]} h-${sizes()[1]}`
        );
      },
      get style() {
        return _$memo(() => !!props.scale)() ? {
          ...props.style ?? {},
          "-webkit-mask-size": `${props.scale}%`,
          "-webkit-mask-position": "center"
        } : props.style;
      }
    }, otherProps), false, true);
    return _el$;
  })();
};

export {
  IconifyNames,
  Iconify
};
//# sourceMappingURL=chunk-LKUMTIYE.js.map